// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrgSwitcher-module__root___ZvznM {
  position: relative;
}

.OrgSwitcher-module__trigger___zXFZG {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #f4f4f5;
  color: #18181b;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1;
}
.OrgSwitcher-module__trigger___zXFZG:hover {
  background: #ececed;
  border-color: #d4d4d8;
}
.OrgSwitcher-module__trigger___zXFZG:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.OrgSwitcher-module__triggerLabel___ucNUn {
  font-size: 12px;
  font-weight: 500;
  color: #a1a1aa;
}

.OrgSwitcher-module__triggerValue___K7n0F {
  color: #18181b;
}

.OrgSwitcher-module__chevron___wAuXj {
  color: #a1a1aa;
  flex-shrink: 0;
}

.OrgSwitcher-module__dropdown___p_uJl {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 50;
  min-width: 240px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 4px;
}

.OrgSwitcher-module__optionRow___KTPBj {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 5px;
}
.OrgSwitcher-module__optionRow___KTPBj:hover {
  background: #f4f4f5;
}

.OrgSwitcher-module__option___qU5Am {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: left;
  min-width: 0;
}

.OrgSwitcher-module__optionActive___TVTRx {
  font-weight: 600;
  color: #18181b;
}

.OrgSwitcher-module__optionCheck___wd4_c {
  color: #18181b;
  flex-shrink: 0;
}

.OrgSwitcher-module__optionLabel___zdCuZ {
  flex: 1;
}

.OrgSwitcher-module__defaultBadge___iKFOX {
  flex-shrink: 0;
  margin-right: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a1a1aa;
  border: 1px solid #e4e4e7;
  border-radius: 3px;
  background: #ffffff;
  white-space: nowrap;
}

.OrgSwitcher-module__makeDefaultBtn___ifBZp {
  flex-shrink: 0;
  margin-right: 10px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 500;
  color: #71717a;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
}
.OrgSwitcher-module__makeDefaultBtn___ifBZp:hover:not(:disabled) {
  color: #18181b;
  border-color: #e4e4e7;
  background: #ffffff;
}
.OrgSwitcher-module__makeDefaultBtn___ifBZp:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/OrgSwitcher/OrgSwitcher.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;EACA,qBAAA;AACJ;AAEE;EACE,0BAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AADF;AAGE;EACE,mBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,OAAA;AAFF;;AAKA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAFF;AAIE;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,YAAA;EACA,mBAAA;AAHJ","sourcesContent":[".root {\n  position: relative;\n}\n\n.trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #f4f4f5;\n  color: #18181b;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 1;\n\n  &:hover {\n    background: #ececed;\n    border-color: #d4d4d8;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #18181b;\n    outline-offset: 2px;\n  }\n}\n\n.triggerLabel {\n  font-size: 12px;\n  font-weight: 500;\n  color: #a1a1aa;\n}\n\n.triggerValue {\n  color: #18181b;\n}\n\n.chevron {\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  z-index: 50;\n  min-width: 240px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  padding: 4px;\n}\n\n.optionRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 5px;\n\n  &:hover {\n    background: #f4f4f5;\n  }\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  padding: 8px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  background: transparent;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  text-align: left;\n  min-width: 0;\n}\n\n.optionActive {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.optionCheck {\n  color: #18181b;\n  flex-shrink: 0;\n}\n\n.optionLabel {\n  flex: 1;\n}\n\n.defaultBadge {\n  flex-shrink: 0;\n  margin-right: 10px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #a1a1aa;\n  border: 1px solid #e4e4e7;\n  border-radius: 3px;\n  background: #ffffff;\n  white-space: nowrap;\n}\n\n.makeDefaultBtn {\n  flex-shrink: 0;\n  margin-right: 10px;\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #71717a;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  cursor: pointer;\n  white-space: nowrap;\n\n  &:hover:not(:disabled) {\n    color: #18181b;\n    border-color: #e4e4e7;\n    background: #ffffff;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OrgSwitcher-module__root___ZvznM`,
	"trigger": `OrgSwitcher-module__trigger___zXFZG`,
	"triggerLabel": `OrgSwitcher-module__triggerLabel___ucNUn`,
	"triggerValue": `OrgSwitcher-module__triggerValue___K7n0F`,
	"chevron": `OrgSwitcher-module__chevron___wAuXj`,
	"dropdown": `OrgSwitcher-module__dropdown___p_uJl`,
	"optionRow": `OrgSwitcher-module__optionRow___KTPBj`,
	"option": `OrgSwitcher-module__option___qU5Am`,
	"optionActive": `OrgSwitcher-module__optionActive___TVTRx`,
	"optionCheck": `OrgSwitcher-module__optionCheck___wd4_c`,
	"optionLabel": `OrgSwitcher-module__optionLabel___zdCuZ`,
	"defaultBadge": `OrgSwitcher-module__defaultBadge___iKFOX`,
	"makeDefaultBtn": `OrgSwitcher-module__makeDefaultBtn___ifBZp`
};
module.exports = ___CSS_LOADER_EXPORT___;
